import {
    CREATE_USERFORM_BILL_RECEIVING_VERIFY,
    FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_SUCCESS,
    FETCH_BILL_RECEIVING_VERIFY_DATA_FAILURE,
    FETCH_BILL_RECEIVING_VERIFY_DATA_REQUEST,
    FETCH_BILL_RECEIVING_VERIFY_DATA_SUCCESS

} from "./billReceivingVerify.actionType";


export const BILL_RECEIVING_VERIFY = 'billReceivingVerify';

let initialState = {
    loading: false,
    billReceivingVerifyData: [],
    billReceivingVerifiedBRNData: [],
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        fldFKProgram: '',
    },
    errorMessage: '',
    activeKey: 1
}

export let billReceivingVerifyReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BILL_RECEIVING_VERIFY_DATA_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_BILL_RECEIVING_VERIFY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                billReceivingVerifyData: updatePayload.BED
            }

        case FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                billReceivingVerifiedBRNData: updatePayload.BED
            }

        case CREATE_USERFORM_BILL_RECEIVING_VERIFY:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case FETCH_BILL_RECEIVING_VERIFY_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };

        default:
            return state;
    }
}